const carFinder = () => {
  const NAMESPACE = 'whichcar/v1';
  const REST_BASE = 'car-finder';
  const REST_BASE_PATH = `/wp-json/${NAMESPACE}/${REST_BASE}`;
  
  // Support both the original car-finder form and the search modal form
  const forms = [
    document.querySelector('#car-finder-form'),
    document.querySelector('#search-modal-car-finder')
  ].filter(Boolean); // Remove null entries
  
  /**
   *
   * @param callback
   */
  function readyMMS(callback) {
    // in case the document is already rendered
    if (document.readyState !== 'loading') {
      callback();
    }// modern browsers
    else if (document.addEventListener) {
      document.addEventListener('DOMContentLoaded', callback);
    }// IE <= 8
    else {
      document.attachEvent('onreadystatechange', function () {
        if (document.readyState === 'complete') {
          callback();
        }
      });
    }
  }
  
  /**
   * Getting Models for given Make selection...
   *
   * @param {string} make
   * @param {Element} form
   * @returns {Promise<any>}
   */
  async function getModels(make, form) {
    const nonce = form.elements._wpnonce.value;
    let response = await fetch(`${REST_BASE_PATH}/get-models/${make}/?_wpnonce=${nonce}`);
    return await response.json(); // Returns it as Promise
  }
  
  /**
   *
   * @param {Element} selectElement
   */
  function removeMakeModelOptions(selectElement) {
    var i, L = selectElement.options.length;
    for (i = L; i > 0; i--) {
      selectElement.remove(i);
    }
  }
  
  /**
   * Show loading indicator in models select
   * @param {Element} modelsSelect
   */
  function showModelsLoading(modelsSelect) {
    removeMakeModelOptions(modelsSelect);
    modelsSelect.disabled = true;
    
    // Add loading option
    const loadingOption = document.createElement('option');
    loadingOption.value = '';
    loadingOption.disabled = true;
    loadingOption.selected = true;
    modelsSelect.appendChild(loadingOption);
    
    // Animate dots
    let dotCount = 0;
    const baseText = 'Loading models';
    
    const animateText = () => {
      dotCount = (dotCount % 4) + 1; // Cycle from 1 to 4 dots
      loadingOption.text = baseText + '.'.repeat(dotCount);
    };
    
    // Start animation
    animateText();
    const interval = setInterval(animateText, 400);
    
    // Store interval on the select element so we can clear it later
    modelsSelect._loadingInterval = interval;
  }
  
  /**
   *
   * @param {array}  data
   * @param {Element} target
   */
  function copyOptionsToSelect(data, target) {
    // Clear any loading animation
    if (target._loadingInterval) {
      clearInterval(target._loadingInterval);
      delete target._loadingInterval;
    }
    
    removeMakeModelOptions(target);
    
    // Add placeholder option first
    const placeholderOption = document.createElement('option');
    placeholderOption.value = '';
    placeholderOption.text = 'Select a model...';
    placeholderOption.disabled = false;
    placeholderOption.selected = true;
    target.appendChild(placeholderOption);
    
    // Add model options
    data.forEach((make) => {
      const option = document.createElement('option');
      option.value = make.id;
      option.text = make.name;
      target.appendChild(option);
    })
    
  }
  
  /**
   * Update submit button state based on form selections
   * @param {Element} form
   */
  function updateSubmitButtonState(form) {
    const submitButton = form.querySelector('button[type="submit"]');
    if (!submitButton) return;
    
    // Determine selectors based on form ID
    const isSearchModal = form.id === 'search-modal-car-finder';
    const makesSelector = isSearchModal ? '#search-modal-makes-list' : '#makes-list';
    
    const makesSelect = form.querySelector(makesSelector);
    
    if (makesSelect) {
      const makeSelected = makesSelect.value !== '';
      
      // Enable button if a make is selected (model is optional)
      submitButton.disabled = !makeSelected;
    }
  }
  
  /**
   *
   * @param {string} make
   * @param {Element} form
   * @param {Element} modelsSelect
   * @returns {Promise<void>}
   */
  async function fetchModels(make, form, modelsSelect) {
    await getModels(make, form).then((response) => {
      if (response.success) {
        copyOptionsToSelect(response.data, modelsSelect);
        modelsSelect.disabled = false;
        
        // Update button state after models are loaded
        updateSubmitButtonState(form);
      }
    });
  }
  
  async function findCar(form) {
    let response = await fetch(`${REST_BASE_PATH}/find-car/`, {
      method: 'POST',
      body: new FormData(form),
    });
    return await response.json();
  }
  
  // Set up event listeners for all forms
  forms.forEach(form => {
    if (form) {
      readyMMS(function () {
        // Determine selectors based on form ID
        const isSearchModal = form.id === 'search-modal-car-finder';
        const makesSelector = isSearchModal ? '#search-modal-makes-list' : '#makes-list';
        const modelsSelector = isSearchModal ? '#search-modal-models-list' : '#models-list';
        
        const makesSelect = form.querySelector(makesSelector);
        const modelsSelect = form.querySelector(modelsSelector);
        
        if (makesSelect && modelsSelect) {
          // Initialize button state
          updateSubmitButtonState(form);
          
          makesSelect.addEventListener('change', (evt) => {
            // Reset model selection when make changes
            modelsSelect.selectedIndex = 0;
            showModelsLoading(modelsSelect);
            fetchModels(evt.target.value, form, modelsSelect);
            updateSubmitButtonState(form);
          });
          
          modelsSelect.addEventListener('change', () => {
            updateSubmitButtonState(form);
          });
        }
      });
      
      form.addEventListener('submit', async (evt) => {
        evt.preventDefault();
        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) {
          submitButton.disabled = true;
        }
        
        await findCar(form).then((response) => {
          if (response.success && response.data.redirect_url) {
            window.location.href = response.data.redirect_url;
          } else {
            console.error('Failed to find Make/Model');
            if (submitButton) {
              submitButton.disabled = false;
            }
          }
        });
      });
    }
  });
}

export {carFinder};
